/* Play Bear editorial Blog P0 — client-side table of contents */
(() => {
  const slugify = (value) => value.toLowerCase().normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  document.querySelectorAll('[data-pb-editorial-article]').forEach((article) => {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    const guide = article.querySelector('[data-pb-article-guide]');
    const list = article.querySelector('[data-pb-article-guide-list]');
    const headings = [...article.querySelectorAll('.pb-article-body h2')];
    if (!guide || !list || headings.length < 2) return;
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `${slugify(heading.textContent || '') || 'secao'}-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.append(link);
      list.append(item);
    });
    guide.hidden = false;
  });
})();
